export default "__VITE_PUBLIC_ASSET__901eef52__"